import React from "react";
import { Printer, Pencil, Trash2, LogOut, Map } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n";

// Compact row actions: print fiche, print fiche+map, edit, checkout, delete
export default function RowActions({ r, onEdit, onDelete, onCheckout, withMap = false, noPrint = false }) {
  const { t } = useLang();
  const lang = r.booker?.language || r.language || "nl";
  const open = (map) => window.open(`/print?res=${r.id}&map=${map ? 1 : 0}&lang=${lang}`, "_blank");
  return (
    <div className="flex items-center justify-end gap-0.5 whitespace-nowrap">
      {!noPrint && <Button variant="ghost" size="icon" className="h-8 w-8" title={t("print_fiche")} onClick={() => open(false)} data-testid={`print-fiche-${r.id}`}><Printer className="h-4 w-4" /></Button>}
      {!noPrint && withMap && <Button variant="ghost" size="icon" className="h-8 w-8" title={t("print_fiche_map")} onClick={() => open(true)} data-testid={`print-fiche-map-${r.id}`}><Map className="h-4 w-4" /></Button>}
      {onEdit && <Button variant="ghost" size="icon" className="h-8 w-8" title={t("edit")} onClick={() => onEdit(r)} data-testid={`edit-reservation-${r.id}`}><Pencil className="h-4 w-4" /></Button>}
      {onCheckout && <Button variant="ghost" size="icon" className="h-8 w-8" title={t("checkout")} onClick={() => onCheckout(r)} data-testid={`checkout-res-${r.id}`}><LogOut className="h-4 w-4 text-amber-600" /></Button>}
      {onDelete && <Button variant="ghost" size="icon" className="h-8 w-8" title={t("delete")} onClick={() => onDelete(r)} data-testid={`delete-reservation-${r.id}`}><Trash2 className="h-4 w-4 text-rose-500" /></Button>}
    </div>
  );
}
